var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"btn f-file-input-btn",attrs:{"id":_vm.id,"tabindex":"0","role":"button"}},[_c('input',_vm._b({attrs:{"id":_vm.cId,"type":"file","tabindex":"-1","accept":_vm.accept},on:{"change":_vm.onFFileInputButtonChange}},'input',_vm.inputProps,false)),_c('label',{attrs:{"for":_vm.cId}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }